import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const BoredomImages = ({ id }) => {
    const data = useStaticQuery(graphql`
        query {
            cover_1: file(relativePath: { eq: "boredom/motif/cover_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_2: file(relativePath: { eq: "boredom/motif/cover_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_3: file(relativePath: { eq: "boredom/motif/cover_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_4: file(relativePath: { eq: "boredom/motif/cover_4.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_5: file(relativePath: { eq: "boredom/motif/cover_5.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_6: file(relativePath: { eq: "boredom/motif/cover_6.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_7: file(relativePath: { eq: "boredom/motif/cover_7.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            motif_1: file(relativePath: { eq: "boredom/motif/motif_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_2: file(relativePath: { eq: "boredom/motif/motif_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_3: file(relativePath: { eq: "boredom/motif/motif_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_4: file(relativePath: { eq: "boredom/motif/motif_4.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <Img style={{ width: "100%" }} fluid={data[id].childImageSharp.fluid} />
    )
}

export default BoredomImages
